import { Stack, Text, Flex } from '@pairy/pds-react';
import styled from '@emotion/styled';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const CloseButton = styled.button`
  min-width: 25px;
`;

export const Description = styled(Text)`
  padding: 0 32px;
`;

export const Modal = styled(Stack)`
  position: absolute;
`;

export const ModalBody = styled(Stack)`
  z-index: ${VIEWER_Z_INDEX.ctaFormLayer};
  width: 100%;
  height: 100dvh;
  padding: 32px 32px calc(32px + env(safe-area-inset-bottom));
  background-color: ${theme.colors.white};
  border-radius: 8px 8px 0 0;
`;

export const ModalContents = styled(Stack)`
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  height: 100dvh;
  max-height: calc(100dvh - 324px);

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Dim = styled.div`
  position: fixed;
  z-index: ${VIEWER_Z_INDEX.layer};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(0.5rem);
  background-color: rgb(0 0 0 / 50%);
`;

export const FlexFixedBottomCTAButtonWrapper = styled(Flex)`
  position: fixed;
  bottom: 0;
  left: 0;
  background: linear-gradient(0deg, #fff 30.73%, rgb(255 255 255 / 0%) 100%);
  gap: 8px;
`;
